<template>
  <div class="logo" :class="{ 'logo--business': Boolean(adminLogoVariant) }">
    <img v-if="image" class="logo__img" :src="image" :alt="alt || 'Logo'" />
    <skribble-logo v-else class="logo__img" :admin-logo-variant />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    adminLogoVariant?: 'dark' | 'light'
    image?: string
    alt?: string
  }>(),
  {
    alt: '',
  }
)
</script>

<style lang="scss" scoped>
$ns: logo;
$logo-stage-width: 190px;
$logo-stage-height: 50px;

$logo-stage-width-business: 250px;
$logo-stage-height-business: 27.69px;

.#{$ns} {
  display: flex;
  align-items: center;
  width: $logo-stage-width;
  height: $logo-stage-height;
  box-sizing: content-box;
  @include maw(xs) {
    justify-content: center;
    width: 0.75 * $logo-stage-width;
    height: 0.75 * $logo-stage-height;
  }

  &__img {
    max-width: $logo-stage-width;
    max-height: $logo-stage-height;
    @include maw(xs) {
      max-width: 0.75 * $logo-stage-width;
      max-height: 0.75 * $logo-stage-height;
    }
  }
  &--business {
    width: max-content;
    height: $logo-stage-height-business;
    margin-left: 0 !important;
    @include maw(sm) {
      height: 23.26px;
    }

    .#{$ns}__img {
      max-width: $logo-stage-width-business;
      height: $logo-stage-height-business;
      @include maw(sm) {
        height: 23.26px;
      }

      img {
        height: 100%;
        display: block;
      }
    }
  }
}
</style>
